import { render, staticRenderFns } from "./KioskInfo.vue?vue&type=template&id=85ad77ba&scoped=true"
import script from "./KioskInfo.vue?vue&type=script&lang=js"
export * from "./KioskInfo.vue?vue&type=script&lang=js"
import style0 from "./KioskInfo.vue?vue&type=style&index=0&id=85ad77ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ad77ba",
  null
  
)

export default component.exports